export default __webpack_public_path__ + "static/media/095953cb232de99d7ba1ed614ee47c3a.png";